import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'bomModelByReference',
    standalone: false
})
export class BomModelByReferencePipe implements PipeTransform {

  transform(bomModels: IBomModel[], reference: string): IBomModel {
    return bomModels?.find(model => model?.article?.ref === reference);
  }

}
